import { cn } from '../../lib/utils';

interface LoadingSpinnerProps {
  className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div 
        className={cn(
          'animate-spin rounded-full h-4 w-4 border-2 border-b-2 border-white border-b-transparent',
          className
        )} 
      />
    </div>
  );
} 